import { useNavigate } from "react-router-dom";

export default function Footer() {
    
    const navigate = useNavigate();
    const handleRoute = () => {
    navigate("/termsandconditions");
    };
     const handleRoute1 = () => {
    navigate("/Privacypolicy");
    };



  return (
    <footer className="footer">
      <div className="footerContainer">
        <p className="footerSubtext">Fresh. Pure. Delivered with Love.</p>
        <p className="footerText">© 2025 Mahaas Dairy Products</p>
        <p className="footerText1" onClick={handleRoute}>Terms and Conditions</p>
        <p className="footerText1" onClick={handleRoute1}>Privacy Policy</p>
      </div>
    </footer>
  )
}